<mat-card fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" fxFlex="100" [formGroup]="form">
  <mat-card-title>Create Duty Entry</mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content
    *tdLoading="
      'duty-edit-form';
      mode: 'indeterminate';
      type: 'circle';
      strategy: 'overlay';
      color: 'primary'
    "
  >
    <div
      gdAreas="employee employee employee | dutyStart dutyEnd base | comments comments aircraft | errors errors errors"
      gdGap="20px"
    >
      <fl-employee-autocomplete
        gdArea="employee"
        formControlName="employeeId"
      ></fl-employee-autocomplete>
      <kendo-textbox-container gdArea="dutyStart" floatingLabel="Duty on time">
        <kendo-dateinput
          [format]="dateTimeFormat"
          formControlName="dutyPeriodStartTime"
        ></kendo-dateinput>
      </kendo-textbox-container>
      <kendo-textbox-container gdArea="dutyEnd" floatingLabel="Duty off time">
        <kendo-dateinput
          [format]="dateTimeFormat"
          formControlName="dutyPeriodEndTime"
        ></kendo-dateinput>
      </kendo-textbox-container>
      <fl-message-box gdArea="errors" level="error" [messages]="errors$ | async"></fl-message-box>
      <fl-base-autocomplete-v2
        gdArea="base"
        hint="Required"
        [disableGoldenHourBases]="true"
        formControlName="baseId"
      ></fl-base-autocomplete-v2>
      <fl-aircraft-autocomplete-v2
        gdArea="aircraft"
        hint="Required"
        formControlName="aircraftId"
      ></fl-aircraft-autocomplete-v2>
      <div gdArea="comments" fxLayout="column" fxLayoutGap="20px">
        <mat-form-field
          fxFlex
          fxFill
          [style.display]="(dutyTimeExceeds14Hours$ | async) ? 'block' : 'none'"
        >
          <textarea
            matInput
            matTextareaAutosize
            formControlName="justification"
            placeholder="Excess Duty Time Justification"
          ></textarea>
          <mat-error *ngIf="form.controls.justification.errors as errors">{{
            errors.justificationRequiredForDutyTimesExceeding14Hours.message
          }}</mat-error>
        </mat-form-field>
        <mat-form-field fxFill>
          <textarea
            matInput
            matTextareaAutosize
            formControlName="comments"
            placeholder="Comments"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
  <mat-divider></mat-divider>
  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="create()" [disabled]="form.invalid">
      Create
    </button>
  </mat-card-actions>
</mat-card>
